export default __webpack_public_path__ + "75057a5d28e268f86ae7d4a5bc853baf.gif";